import React, { useEffect } from "react"
import SystemCard from "../../components/SystemCard/SystemCard"
import { ArrowLeft, Headphones, BarChart3, Users, Settings, Database, Shield } from "lucide-react"
import { Button } from 'react-bootstrap';
import "./SystemsContainer.css"
import { connect, useDispatch } from "react-redux";
import { getAllSystems } from "../../redux/actions/systemsActions";


const SystemsContainer = (props) => {

  const { loading, systems, onNavigateToHome, token } = props
  const dispatch = useDispatch()
  useEffect(() => {
    //console.log("El token es", token)
    dispatch(getAllSystems(token))
  }, [token])


  /* const systems = [
    {
      id: 1,
      name: "Sistema de Tickets",
      description: "Gestión completa de tickets de soporte y seguimiento de incidencias",
      icon: "bi-headset",
      status: "active",
      url: "#",
    },
    {
      id: 2,
      name: "CRM Empresarial",
      description: "Administración de clientes, contratos y relaciones comerciales",
      icon: "bi-people",
      status: "active",
      url: "#",
    },
    {
      id: 3,
      name: "Monitoreo Grafana",
      description: "Dashboards de monitoreo en tiempo real y métricas de rendimiento",
      icon: "bi-bar-chart",
      status: "active",
      url: "#",
    },
    {
      id: 4,
      name: "Panel de Control",
      description: "Configuración de servicios y administración de recursos",
      icon: "bi-gear",
      status: "active",
      url: "#",
    },
    {
      id: 5,
      name: "Base de Datos",
      description: "Acceso a reportes y consultas de base de datos empresarial",
      icon: "bi-database",
      status: "maintenance",
      url: "#",
    },
    {
      id: 6,
      name: "Seguridad",
      description: "Centro de seguridad y gestión de accesos y permisos",
      icon: "bi-shield-check",
      status: "active",
      url: "#",
    },
  ] */

  const getStatusBadge = (status) => {
    switch (status) {
      case "active":
        return <span className="badge bg-success">Activo</span>
      case "maintenance":
        return <span className="badge bg-warning text-dark">Mantenimiento</span>
      default:
        return <span className="badge bg-secondary">Desconocido</span>
    }
  }

  const handleOpenSystem = (url, name) => {
    //console.log(`Abriendo ${name} en: ${url}`)
    window.open(url, "_blank")
  }

  return (
    <div className="min-vh-100 systems-container">
      {/* Header */}
      <header className="systems-header mt-4">
        <div className="container-fluid">
          <div className="row align-items-center py-3">
            <div className="col ms-1 ms-md-4">
              <div className="d-flex align-items-center">
                <div>
                  <h1 className="h3 mb-1 fw-semibold systems-title">Sistemas Disponibles</h1>
                  <p className="systems-subtitle mb-0">Accede a todos tus sistemas empresariales</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <main className="container-fluid py-4">
        {/* Systems Grid */}
        <div className="systems-section">
          {systems?.map((system, index) => (
            <SystemCard key={index} system={system}/>
          ))}
        </div>
        {/* Info Section */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="card border-0 shadow-sm info-card">
              <div className="card-body p-4">
                <div className="d-flex align-items-start">
                  <div>
                    <h5 className="fw-semibold info-title mb-2">¿Necesitas acceso a un sistema adicional?</h5>
                    <p className="info-text small mb-0">
                      Si requieres acceso a sistemas adicionales o tienes problemas para acceder a alguno de los
                      sistemas listados, contactanos a <a href="mailto:soporte@rocstar.tv">soporte@rocstar.tv</a>.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
const mapStateToProps = (state) => {
  return {
    loading: state.system.loading,
    systems: state.system.all_systems,
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(SystemsContainer);